import React from 'react';
import { IconButton } from 'wix-ui-tpa/cssVars';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { ChevronDownSmall } from '@wix/wix-ui-icons-common/on-stage';
import { useExperiments } from '@wix/yoshi-flow-editor';

interface ArrowDownProps {
  className?: string;
  containerClassName?: string;
  dataHook?: string;
  open: boolean;
}

export const CollapsibleState: React.FC<ArrowDownProps> = ({ className, dataHook, open, containerClassName }) => {
  const { experiments } = useExperiments();
  const isFocusFixEnabled = experiments.enabled(TPA_EXPERIMENTS.PERKS_ARROW_FOCUS_FIX);

  if (isFocusFixEnabled) {
    return (
      <div className={containerClassName}>
        <IconButton
          fullWidth={true}
          data-hook={dataHook}
          className={className}
          aria-label={open ? 'collapse' : 'expand'}
          aria-expanded={open}
          icon={<ChevronDownSmall fillOpacity="0.6" />}
        />
      </div>
    );
  }

  return (
    <button data-hook={dataHook} className={className} aria-label={open ? 'collapse' : 'expand'} aria-expanded={open}>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
        <path
          fill="#000"
          fillOpacity=".6"
          fillRule="evenodd"
          d="M10.95.293l.707.707L6 6.657.343 1 1.05.293 6 5.243l4.95-4.95z"
        />
      </svg>
    </button>
  );
};
